import React from "react"

import LoanPayoff from "activities/calculators/early-payoff"
import merge from "lodash/merge"

export default (props) => (
  <LoanPayoff
    {...merge(
      {
        id: "early-payoff",
        title: "Early Payoff Calculator",
        subtitle: "Explore what it would take to pay off your mortgage early.",
        amountTitle: "Home Price",
        downPayment: {
          show: true,
          step: 5000
        },
        loanTerm: {
          min: 5,
          max: 30,
          step: 5
        },
        addedPayment: {
          min: 0,
          max: (payment) => Math.floor((payment * 3) / 100) * 100,
          step: 100
        },
        interestRate: {
          min: 1.5,
          max: 8,
          step: 0.05
        },
        initialState: {
          price: 250000,
          payment: 50000,
          years: 30,
          rate: 4.75,
          additionalPayment: 1000
        },
        ariaLabel:
          "This line graph visually represents how much sooner you could pay off your mortgage. Read below to find the monthly payment, interest saved, interest to be paid, and the date the loan will be paid off."
      },
      props
    )}
  />
)
